import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, UserPlus, CalendarPlus, ListPlus, FilePlus2, ClipboardPlus, BookPlus, HeartHandshake } from "lucide-react";

const ACTIONS = [
  { label: "New Client", to: "/engagement/intake/new", icon: UserPlus },
  { label: "New Appointment", to: "/scheduler", icon: CalendarPlus },
  { label: "New Task", to: "/tasks", icon: ListPlus },
  { label: "New Progress Note", to: "/clinical/progress-notes/new", icon: FilePlus2 },
  { label: "New Treatment Plan", to: "/clinical/treatment-plans/new", icon: ClipboardPlus },
  { label: "New Assessment", to: "/clinical/assessments", icon: ClipboardPlus },
  { label: "Add Education Resource", to: "/resources", icon: BookPlus },
  { label: "Invite Client to Portal", to: "/clients", icon: HeartHandshake },
];

export function QuickAdd() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  return (
    <div className="relative" ref={ref}>
      <button data-testid="header-quick-add-btn" aria-label="Quick add" onClick={() => setOpen(!open)}
        className={`flex h-9 w-9 items-center justify-center rounded-full transition-all ${open ? "bg-[#FFB300] text-[#3E2723] rotate-45" : "bg-white/10 hover:bg-white/20 text-white"}`}>
        <Plus size={18} />
      </button>
      {open && (
        <div data-testid="quick-add-menu" className="absolute right-0 top-12 z-[95] w-60 rounded-2xl border border-[#EFEBE0] bg-white text-[#3E2723] shadow-[0_16px_48px_-12px_rgba(62,39,35,0.35)] py-2">
          <div className="px-4 pt-1 pb-2 text-[10px] font-bold uppercase tracking-[0.08em] text-[#84675B]">Quick create</div>
          {ACTIONS.map(({ label, to, icon: Icon }) => (
            <button key={label} data-testid={`quick-add-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              onClick={() => { setOpen(false); navigate(to); }}
              className="flex w-full items-center gap-3 px-4 py-2 text-left text-sm hover:bg-[#F5F2EB]">
              <Icon size={15} className="text-[#7B6157]" /> {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
